import moment from 'moment'
import {API_URL, fetchPlaces, outreachService} from '../_services'
import axios from 'axios'
import {authHeader} from '../_helpers'

const getDefaultState = () => {
  return {
    items: [],
    status: 'empty'
  }
}


export const newOutreachReports = {
  namespaced: true,
  state: {
    id:'new',
    date: moment().format('YYYY-MM-DD'),
    place: '',
    hours: 3,
    users: [],
    volunteers: '',
    customers: [],
    warmth: '',
    descLetter: '',
    products: [],
    tests: [],
    globalIndicators: [],
    customerPerConsult: [],
    consultPerCustomers: [],
    project:'',
    profile:'',
    deletedCustomers: []
  },
  mutations: {
    setReportId (state, reportId) {
      state.id = reportId
      // //console.log(state, reportId)
    },
    setCustomerPerConsult (state, payload) {
      state.customerPerConsult = payload
    },
    setConsultPerCustomers (state, payload) {
      state.consultPerCustomers = payload
    },
    setglobalIndicators (state, payload) {
      state.globalIndicators = payload
    },
    setDate (state, date) {
      state.date = date
    },
    setProject (state, project) {
      state.project = project
    },
    setProfile (state, profile) {
      state.profile = profile
    },
    setLocation (state, place) {
      state.place = place
    },
    setHours (state, length) {
      state.hours = length
    },
    setVolunteers (state, volunteers) {
      state.volunteers = volunteers
    },
    setOther (state, data) {
      state.descLetter = data
    },
    setWarmth (state, warmth) {
      state.warmth = warmth
    },
    setEmlpoyees (state, employees) {
      state.users = employees
    },
    addCustomer (state, client) {
      let index = client['index']>-1 ? client['index'] : 0
      state.customers.splice(index, 0, client['client'])
    },
    deleteCustomer (state, code, type='outreach', exec=true) {
      const index = state.customers.findIndex(client => client.code === code)
      state.customers.splice(index, 1)
      let data = {'full_code':code,'report_id':state.id}
      return  axios.post(
            `${API_URL}/api/reports/${type}/${state.id}`,
            data,
            {headers: authHeader()}
          ).then(res => res)

    },
    deleteCustomerLocal (state, code,) {
      const index = state.customers.findIndex(client => client.code === code)
      state.customers.splice(index, 1)
      state.deletedCustomers.push(code)
    },
    populateReport (state, report) {
      report.customers.map(v => v.customer).forEach(v => {
        v['products'] = report.products ? report.products[v.full_code] : []
        v['consultings'] = report.consultings ? report.consultings[v.full_code] : []
        v['tests'] = report.tests ? report.tests[v.full_code] : []
        v['directions'] = report.directions ? report.directions[v.full_code] : []
        v['code'] = v.full_code
      })
      let customers = state.customers.map(v => v['full_code'])
      report.customers.sort(function (a, b){
          return customers.indexOf(a['customer']['full_code']) - customers.indexOf(b['customer']['full_code'])
        })
      // state.customers = report.customers.filter(x => state.deletedCustomers.indexOf(x.full_code)===-1).map(v => {
      state.customers = report.customers.map(v => {
        v.customer.customerGroups = v.customer.customergroups ? v.customer.customergroups : []
        v.customer.education = v.customer.education ? v.customer.education : null
        v.customer.is_treatment = v.customer.is_treatment ? v.customer.is_treatment : null

        // v.customer.tests = v.customer.products ? v.customer.products.filter(prod => prod.producttype === 4) : []
        // v.customer.tests = v.customer.tests.map(t => { t.additional = (t.additional === 'True' || t.additional === 1 || t.additional === 'true'); return t })
        v.customer.tests = v.customer.tests ? v.customer.tests : []
        v.customer.tests.forEach(v => v.result.is_tested=v.result.result !== null)
        v.customer.products = v.customer.products ? v.customer.products.filter(prod => prod.producttype !== 2 && prod.producttype !== 4) : []
        v.customer.consultings = v.customer.consultings ? v.customer.consultings : []

        v.customer.directions = v.customer.directions ? v.customer.directions : []
        return v.customer
      })
      state.id = report.id
      state.project = report.project ? report.project.id : null
      state.date = report.date
      state.place = report.place ? report.place.id : null
      state.hours = report.hours
      state.users = report.users
      state.volunteers = report.volunteers ? report.volunteers : null
      state.warmth = report.warmth ? report.warmth : null
      state.descLetter = report.descLetter ? report.descLetter : null
      state.deletedCustomers=[]
      return state
    },
    clearReport (state) {
      state.date = moment().format('YYYY-MM-DD')
      state.products = []
      state.tests = []
      state.place = ''
      state.id = 'new'
      state.hours = 3
      // state.users = []
      state.volunteers = ''
      state.customers = []
      state.warmth = ''
      state.descLetter = ''
    },
    resetState (state) {
      Object.assign(state, getDefaultState())
    }

  },
  actions: {
    addCustomers (state, {customers, tests=[], products=[], consultings=[],directions=[], customerGroups, customerEducation, customerTreatment,reportType}) {
      const cust = [...state.state.customers]
      if (customers.length === 1) {
        const index = cust.findIndex(client => client.code === customers[0])
        if (index !== -1) {
          state.commit('deleteCustomerLocal', customers[0])
        }
        let custDictStart = index !== -1 ? {id:cust[index].id, sex: cust[0].sex} : {sex:customers[0].slice(-1)}
        const newCustomer = {
          code: customers[0],
          full_code: customers[0],
          // tests: tests.filter(product => product.amount !== 0 && product.amount !== false),
          tests: tests,
          products: products.filter(product => product.amount !== 0 && product.amount !== false),
          consultings: consultings,
          directions: directions,
          customerGroups: customerGroups,
          education:customerEducation,
          is_treatment:customerTreatment
        }
        state.commit('addCustomer', {client: {...custDictStart,...newCustomer}, index: index !== -1 ? index : cust.length+1})
      } else {
        customers.forEach((client, i) => {
          const index = cust.findIndex(client => client.code === client)
          let custDictStart = index !== -1 ? {id:cust[index].id, sex: cust[0].sex} : {sex:customers[0].slice(-1)}
          let newCustomer = {
            code: client,
            full_code: client,
            tests: [],
            products: [],
            consultings: [],
            customerGroups: customerGroups,
            education: customerEducation,
            is_treatment:customerTreatment

          }
          products.forEach((product, j) => {
            if (product.amount === 0 || product.amount === false) {
              return
            }
            const newProduct = Object.assign({}, product)
            if (i === 0) {
              newProduct.amount = Math.floor(product.amount / customers.length) + product.amount % customers.length
              newCustomer.products.push(newProduct)
            } else if (Math.floor(product.amount / customers.length) > 0) {
              newProduct.amount = Math.floor(product.amount / customers.length)
              newCustomer.products.push(newProduct)
            }
          })
          if (reportType!=='outreach') {
            consultings.forEach((consulting, j) => {
              // if (consulting.amount === 0 || consulting.amount === false) {
              //   return
              // }
              // const newConst = Object.assign({}, consulting)
              newCustomer.consultings.push(consulting)
            })
          }
          if (i === 0) {
            // newCustomer.tests = tests.filter(product => product.amount !== 0 && product.amount !== false)
            newCustomer.tests = tests
            // newCustomer.consultings = consultings.filter(product => product.amount !== 0 && product.amount !== false)
          }
          state.commit('addCustomer', {client: {...custDictStart,...newCustomer}, index: null})
        })
      }
    },
    async load (state, {reportId, type}) {
      const report = await outreachService.load(reportId,type)
      report.id = reportId
      state.commit('populateReport', report)

    },
    async saveReport (state, {reportId, type, global, stage, toRename, codes}) {
      const preData = Object.assign({}, state.state)

      preData['stage']=stage
      // let preDataFilteredCustomers = codes ? preData.customers.filter(v => codes.indexOf(v.full_code)>-1) : preData.customers
      let preDataFilteredCustomers = preData.customers
      preDataFilteredCustomers.forEach((client, i) => {
        if (toRename && toRename[client.full_code]) {
          client['oldCode']=toRename[client.full_code]
        }
        if (client.tests) {
          client.tests = client.tests.map((test, i) => {
            let startDict = test.id ? {id:test.id} : {id:null}
            let restDict = {
              tests_id: test.tests_id ? test.tests_id : test.diseasetype.id,
              customers_id:test.customers_id,
              result: test.result,
              report: reportId,
              reports_id: reportId,
              name: test.name,
              redcap_repeat_instance: test.redcap_repeat_instance
            }
            return {...startDict,...restDict}
          })
        } else client.tests = []

        if (client.products) {
          client.products = client.products.map((product, i) => {
            let startDict = product.id ? {id:product.id}: reportId === 'new' ? {id:product.value}:{}
            let restDict = {
                        products_id: product.products_id ? product.products_id: product.value,
                        product: product.products_id ? product.products_id: product.value,
                        customers_id:product.customers_id,
                        amount: product.amount,
                        report: reportId,
                        name: product.name,
                        redcap_repeat_instance: product.redcap_repeat_instance

                      }
            return {...startDict,...restDict}
        })
        } else client.products = []

        if (client.consultings) {
          client.consultings = client.consultings.map((consulting, i) => {
            let startDict = consulting.id ? {id:consulting.id}:  reportId === 'new' ? {id:consulting.value}:{}
            let consultations_id = consulting.consultations_id ? consulting.consultations_id: consulting.id
            let restDict = {
              products_id: consulting.products_id ? consulting.products_id: consulting.value,
              consultations_id: consultations_id ? consultations_id : consulting.value,
              product: consulting.products_id ? consulting.products_id: consulting.value,
              customers_id:consulting.customers_id,
              amount: consulting,
              report: reportId,
              name: consulting.name,
              redcap_repeat_instance: consulting.redcap_repeat_instance
            }
            return {...startDict,...restDict}
        })
        } else client.consultings = []
        if (client.directions) {
          client.directions = client.directions.map((direction, i) => {
            let startDict = direction.id ? {id:direction.id}:  reportId === 'new' ? {id:direction.value}:{}
            let restDict = {
              customers_id:direction.customers_id,
              directions_id: direction.directions_id ? direction.directions_id: direction.value,
              amount: direction,
              report: reportId,
              name: direction.name,
              redcap_repeat_instance: direction.redcap_repeat_instance
            }
            return {...startDict,...restDict}
        })
        } else client.directions = []
        if (!client.customerGroups) {
            client.customerGroups = []
        }
      })
      preData.customers = preDataFilteredCustomers
      // if (global) {
      //   // preData.globalIndicators.push(...global)
      //   preData.globalIndicators = global
      // }
      if(reportId === 'new') {
        await outreachService.save(preData,type).then(resp => {
            // state.commit('updateReportId', resp.data['id'])
            state.commit('populateReport', resp.data)
            state.commit('setReportId',resp.data['id'] )
            state.deletedCustomers=[]
        })
      } else {
        await outreachService.update(preData,reportId,type).then(resp => {

            state.commit('populateReport', resp.data)
            state.deletedCustomers=[]
        })
      }
    },
    resetReportState (state){
      state.commit('resetState')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reports.module.js